import { useMutation } from '@tanstack/react-query';
import { request } from 'javascripts/services/v3ApiClient';
import type {
  V3ApiMetaData,
  V3ApiSuccessData,
  V3ApiErrorData,
} from 'javascripts/services/v3ApiClient';

type CommentTranslationObject = {
  data: {
    translations: {
      [key: string]: string;
    };
  };
  meta: V3ApiMetaData;
  errors: [];
};

export type CreateCommentTranslationResponse = V3ApiSuccessData<
  CommentTranslationObject[]
>;

type CreateCommentTranslationParams = {
  text: string;
  targets: string[];
  provider: 'nova' | 'claude' | 'gpt' | 'unknown';
};

export const useCreateCommentTranslation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (error: any) => void;
  onError?: (error: any) => void;
}) => {
  const { data, isError, isPending, mutate } = useMutation<
    CreateCommentTranslationResponse,
    V3ApiErrorData,
    CreateCommentTranslationParams
  >({
    mutationFn: async (params) => {
      const response = await request({
        url: `dynamic_translations`,
        method: 'POST',
        data: params,
      });
      return response.data;
    },
    onError,
    onSuccess,
  });

  return {
    mutate,
    data,
    isPending,
    isError,
  };
};
